<template>
    <div class="container" id="blog">
        <router-view></router-view>
    </div>
</template>

<script>

import BlogHome from './Blog-Home'

export default {
    name: 'blog',
    componets() {
        BlogHome
    },
    // head: {
    //     title: function () {
    //     return {
    //         inner: "Blog"
    //     }
    //     },
    //     meta: [
    //         { name: 'description', content: 'My description', id: 'desc' }
    //     ]
    // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*BLOG*/
    .blog {
        padding-left: 60px;
        padding-right: 60px;
        padding-bottom: 60px;
    }

    .blog .post {
        padding: 20px;
    }

    .post h2 {
        font-size: 2.5rem;
    }
    /*BLOG*/
</style>



// WEBPACK FOOTER //
// Blog.vue?804fa1de